import React from 'react';
import TrainingGoalsTierPicker from '../TrainingGoalsTierPicker';
import { syncGoalSlugsFromTiers } from '../../utils/trainingGoalTiers';

export default function WizardStepGoals({ formData, onChange }) {
  const handleTiersChange = (tiers) => {
    onChange({
      ...formData,
      trainingGoalTiers: tiers,
      trainingGoalSlugs: syncGoalSlugsFromTiers(tiers),
    });
  };

  return (
    <div className="space-y-5">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-wider text-iron-accent">Objetivos</p>
        <p className="mt-1 text-xs text-iron-muted">
          Escolha pelo menos um objetivo para orientar a divisão e os exercícios.
        </p>
      </div>

      <TrainingGoalsTierPicker
        value={formData.trainingGoalTiers}
        onChange={handleTiersChange}
      />
    </div>
  );
}
